import axios from 'src/admin-axios';
import Constants from 'src/constants';

export const payments = {
    namespaced: true,
    state: {
        productCategoryList: [],
        priceDetails: [],
        taxRates: [],
        WebhooksList: [],
    },
    getters: {
        getProductCategoryList (state) {
            return state.productCategoryList;
        },
        getPriceDetails (state) {
            return state.priceDetails;
        },
        getTaxRates (state) {
            return state.taxRates;
        },
        getWebhooksList (state) {
            return state.WebhooksList;
        },
    },
    mutations: {
        setProductCategoryList (state, data) {
            state.productCategoryList = data;
        },
        setPriceDetails (state, data) {
            state.priceDetails = data;
        },
        setTaxRates (state, data) {
            state.taxRates = data;
        },
        setWebhooksList (state, data) {
            state.WebhooksList = data;
        },
    },
    actions: {
        async fetchProductCategoryList ({ dispatch, commit }) {
            const url = '/payments/products';
            try {
                const details = await axios.get(url);
                commit('setProductCategoryList', details.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting Product Category list.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
        async createProductCategory ({ dispatch }, payload) {
            const url = '/payments/products';
            try {
              await axios.post(url, payload);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in creating the Product category.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async fetchCategoryPriceDetails ({ dispatch, commit }, payload) {
            const url = `/payments/products/${payload.productCategoryId}/prices`;
            try {
                const details = await axios.get(url);
                commit('setPriceDetails', details.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting Price details.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
        async addPrices ({ dispatch }, payload) {
            const url = `/payments/products/${payload.productCategoryId}/prices`;
            try {
              await axios.post(url, payload.priceDetails);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in adding Price.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async  updatePriceStatus ({ dispatch }, payload) {
            const url = `/payments/products/price/${payload.priceId}`;
            try {
                await axios.put(url, payload.priceStatus);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in updating price status.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async fetchTaxRates ({ dispatch, commit }) {
            const url = '/payments/taxes';
            try {
                const details = await axios.get(url);
                commit('setTaxRates', details.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting Tax Rates list.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
        async createTaxRate ({ dispatch }, payload) {
            const url = '/payments/taxes';
           try {
             await axios.post(url, payload);
           } catch (exception) {
               dispatch('alert/onAlert', {
                   message: 'Something went wrong in creating tax rate.',
                   type: Constants.ALERT_TYPE_ERROR,
               }, { root: true });
               throw exception;
           }
       },
       async fetchWebhooksList ({ dispatch, commit }) {
        const url = '/payments/webhooks';
        try {
            const details = await axios.get(url);
            commit('setWebhooksList', details.data);
        } catch (exception) {
            dispatch('alert/onAlert', {
                message: 'Something went wrong in getting Webhooks list.',
                type: Constants.ALERT_TYPE_ERROR,
            }, { root: true });
        }
    },
    },
};
